import { withResult } from 'feathers-fletching';
import { withSearch } from 'src/feathers/hooks';
import { truckType } from 'straightline-utils/constants';
import { validateSchema } from 'straightline-utils/hooks';

const withSearches = withSearch({
  'pickup_address.city': withSearch.string,
  'pickup_address.name': withSearch.string,
  'delivery_address.city': withSearch.string,
  'delivery_address.name': withSearch.string,
  reference_number: withSearch.text,
  id: withSearch.number
});

const withResults = withResult({
  truck: (quote) => {
    if (quote.truck_type) {
      return truckType(quote.truck_type);
    }
  },
  pickup_address: (quote) => {
    if (quote.pickup_address) {
      return {
        ...quote.pickup_address,
        position: {
          lat: Number(quote.pickup_address.latitude),
          lng: Number(quote.pickup_address.longitude)
        }
      };
    }
  },
  delivery_address: (quote) => {
    if (quote.delivery_address) {
      return {
        ...quote.delivery_address,
        position: {
          lat: Number(quote.delivery_address.latitude),
          lng: Number(quote.delivery_address.longitude)
        }
      };
    }
  },
  rate: (quote) => {
    if (quote.rate_id && quote.rates) {
      return quote.rates.find((rate) => rate.id === quote.rate_id);
    }
  },
  rates_range: (quote) => {
    const sortedRates = [...quote.rates].sort((a, b) => {
      return a.price.shipper_price - b.price.shipper_price;
    });
    const min = sortedRates[0].price.shipper_price;
    const max = sortedRates[sortedRates.length - 1].price.shipper_price;
    return { min, max };
  }
});

export default {
  before: {
    all: [withSearches],
    find: [],
    get: [],
    create: [validateSchema],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [withResults],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
};
